/*=========================================================================================
  File Name: moduleMailServerGetters.js
  Description: MailServer Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {
  getMailServersName: state => state.mailServers.map(ms => {
      return {
        name: ms.receive_user_name,
        id: ms.id
      }
    }),
    getFullMailServersName: state => state.fullmailServers.map(ms => {
      return {
        name: ms.receive_user_name,
        id: ms.id
      }
    }),
    
    getAllMailServers: state => state.mailServers.map(ms => {
      return {
        id: ms.id,
        mail_srv_name: ms.mail_srv_name,
        svr_protcol: ms.svr_protcol,
        receive_server_name: ms.receive_server_name,
        receive_user_name: ms.receive_user_name,
        receive_password: ms.receive_password,
        receive_port: ms.receive_port,
        receive_security: ms.receive_security,
        receive_spa: ms.receive_spa,
        sent_server_name: ms.sent_server_name,
        sent_user_name: ms.sent_user_name,
        sent_password: ms.sent_password,
        sent_port: ms.sent_port,
        sent_security: ms.sent_security,
        sent_spa: ms.sent_spa
      }
    }),
    
    timeSyncMailServer: state=> state.timeSyncMailServer,
}